import React from 'react';

const INIT_STATE = {
    enabledModules:{},
    farmModules:{},
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case "USER_MODULES": {
            return {
                ...state,
                enabledModules: action.payload
            };
        }
        case "FARM_MODULES": {
            return {
                ...state,
                farmModules: action.payload
            };
        }
        default:
            return state;
    }
}
